module.exports = __webpack_public_path__ + "static/media/Glyph_Large_Profile.e4b9971e.png";